const translations = {
    loading: 'Loading',
    noBatteries: 'No Batteries',
    noMoreBatteries: 'No More Batteries',
    searchPlaceholder: 'Search batteries by name or serial...'
};

export default translations;
